"use client";
import { useEffect, useState, useRef } from "react";

export default function LottieOverlay() {
	const [animation, setAnimation] = useState(null);
	const [visible, setVisible] = useState(false);
	const lottieRef = useRef(null);

	useEffect(() => {
		const preload = async () => {
			const anim = await import("../public/animations/transition.json");
			setAnimation(anim.default);
		};
		preload();
	}, []);

	useEffect(() => {
		if (typeof window === "undefined") return;

		const updateAnim = async () => {
			if (!animation) return;
			setVisible(true);

			requestAnimationFrame(() => {
				// Vérifier que lottieRef.current existe avant d'accéder à ses propriétés
				if (!lottieRef.current?.lottie) return;

				if (window.document.body.classList.contains("page-exit")) {
					lottieRef.current.lottie.playSegments([0, 60], true);
				} else if (window.document.body.classList.contains("page-enter")) {
					lottieRef.current.lottie.playSegments([60, 120], true);
					lottieRef.current.lottie.addEventListener("complete", () => setVisible(false), { once: true });
				}
			});
		};

		const observer = new MutationObserver(updateAnim);
		setTimeout(() => {
			observer.observe(window.document.body, { attributes: true, attributeFilter: ["class"] });
		}, 1100); // First delay on page load

		return () => observer.disconnect();
	}, [animation]);

	useEffect(() => {
		if (!visible || !animation || !lottieRef.current) return;

		const lottie = require("lottie-web");
		const animInstance = lottie.loadAnimation({
			container: lottieRef.current,
			renderer: "svg",
			loop: false,
			autoplay: false,
			animationData: animation,
			rendererSettings: {
				preserveAspectRatio: "none",
			},
		});
		lottieRef.current.lottie = animInstance;

		return () => {
			if (lottieRef.current) {
				lottieRef.current.lottie = null;
			}
			animInstance.destroy();
		};
	}, [visible, animation]);

	return <div className="transition-container">{visible && animation && <div className="overlay-lottie" ref={lottieRef} />}</div>;
}
